import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { SOP } from '@/types/sop';
import { getDepartmentColorClass } from '@/utils/departmentColors';

interface PublicCategoryPreviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  categoryName: string;
  sops: SOP[];
}

const PublicCategoryPreviewDialog: React.FC<PublicCategoryPreviewDialogProps> = ({
  isOpen,
  onClose,
  categoryName,
  sops
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-white dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle className="text-gray-900 dark:text-white">
            SOPs in {categoryName}
          </DialogTitle>
        </DialogHeader>
        <div className="mt-4 space-y-4">
          {sops.length === 0 ? (
            <div className="text-center py-4 text-gray-500 dark:text-gray-400">
              No SOPs in this category yet.
            </div>
          ) : (
            <div className="grid grid-cols-1 gap-4">
              {sops.map(sop => (
                <div key={sop.id} className="relative flex flex-col py-3 hover:bg-gray-100 dark:hover:bg-gray-800/50 border-b dark:border-gray-700 last:border-b-0">
                  <div className="flex items-center justify-between">
                    <div className="flex-1">
                      <div className="flex items-center gap-4">
                        <a
                          href={sop.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm font-medium text-gray-900 dark:text-gray-100 hover:text-green-600 dark:hover:text-green-400"
                        >
                          {sop.title}
                        </a>
                      </div>
                      <div className="mt-1 flex items-center gap-2">
                        <span className="text-sm text-gray-500 dark:text-gray-400">
                          {sop.author1 && `By: ${sop.author1}`}
                          {sop.author1 && sop.author2 && ', '}
                          {sop.author2}
                        </span>
                        {sop.department.split(',').map((dept, index) => {
                          const trimmedDept = dept.trim();
                          return trimmedDept ? (
                            <span
                              key={`${trimmedDept}-${index}`}
                              className={`inline-flex items-center rounded-md px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${getDepartmentColorClass(trimmedDept, index)}`}
                            >
                              {trimmedDept}
                            </span>
                          ) : null;
                        })}
                        {sop.tags?.map(tag => (
                          <span
                            key={tag}
                            className="inline-flex items-center rounded-md bg-gray-50 dark:bg-gray-800 px-2 py-0.5 text-xs font-medium text-gray-600 dark:text-gray-300 ring-1 ring-inset ring-gray-500/10 dark:ring-gray-700"
                          >
                            {tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PublicCategoryPreviewDialog;